import { axiosApi } from "../../../../../api/dbAxios";
import { RegulatorsByCountryResponse } from "../interfaces/regulatorsByCountry.interface";

export const fetchRegulatorsByCountry = async (): Promise<RegulatorsByCountryResponse> => {
  try {
    const response = await axiosApi.get<RegulatorsByCountryResponse>(`/regulators_by_country/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching regulators by country:", error);
    return [];
  }
};
